import { useEffect, useRef } from "react";

/** Subtle cursor-following bloom. Disabled on touch + reduced motion. */
export const CursorLight = () => {
  const ref = useRef(null);

  useEffect(() => {
    const reduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    const isTouch = window.matchMedia("(pointer: coarse)").matches;
    if (reduced || isTouch) return;

    const el = ref.current;
    if (!el) return;

    let tx = window.innerWidth * 0.7;
    let ty = window.innerHeight * 0.3;
    let x = tx;
    let y = ty;
    let raf = 0;

    const onMove = (e) => {
      tx = e.clientX;
      ty = e.clientY;
    };
    window.addEventListener("mousemove", onMove, { passive: true });

    const loop = () => {
      x += (tx - x) * 0.08;
      y += (ty - y) * 0.08;
      el.style.transform =
        "translate3d(" + x + "px," + y + "px,0) translate(-50%,-50%)";
      raf = requestAnimationFrame(loop);
    };
    loop();

    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      ref={ref}
      data-testid="cursor-light"
      aria-hidden="true"
      className="pointer-events-none fixed left-0 top-0 z-[2] h-[480px] w-[480px] rounded-full opacity-60 mix-blend-screen blur-3xl"
      style={{
        background:
          "radial-gradient(circle, rgba(215,220,227,0.16), rgba(215,220,227,0) 62%)",
      }}
    />
  );
};
